<div class="information card" (clickedOutside)="onClickOutside()" clickOutside>
  <close-button (clickButton)="onCloseModal()"></close-button>

  <div class="information__container">
    <div class="information__subtitle" [innerHTML]="title"></div>
  </div>
</div>
